export default __webpack_public_path__ + "static/qrdiscord-3a49db176640a85254a8bee9a53ddc22.png";